module.exports = __webpack_public_path__ + "images/smartphone-screen-4_7f7a2eb4965e2044cf0a8aa60c9a3d92.png";